import { arrayOf, objectOf } from "@altostra/type-validations";
import { any, number, string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult } from "./types";

const isPerformanceReportKpiResult = objectOf({
  id: string,
  status: string,
  dates: arrayOf(string),
  numerator_base: number,
  denominator_base: number,
  value_base: number,
  numerator_comparison: number,
  denominator_comparison: number,
  value_comparison: number,
  uplift: number,
  uplift_per_day: arrayOf(number),
  values_comp_per_day: arrayOf(number),
  values_base_per_day: arrayOf(number),
  one_tailed_p_value: objectOf({
    p_value: number,
    reason: string,
    reason_description: string,
  }),
  error: any,
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult = objectOf({
  kpis: arrayOf(isPerformanceReportKpiResult),
}) as (value: unknown) => value is GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult;
